export const engagementCanvasesData = "/engagement/canvases_data/";
